import { render, staticRenderFns } from "./TrendMock.vue?vue&type=template&id=351423d2&"
import script from "./TrendMock.vue?vue&type=script&lang=js&"
export * from "./TrendMock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports